import React, { useEffect } from "react";
import * as reduxSelectors from "../store/application.reducers";
import { connect } from "react-redux";
import {
    getCostUnits,
    getOldWorkflowJSON,
    getOrganizationChart,
    getRuleConfigurationRoles,
    removeActiveWorkflow,
    removeStep,
    renameRule,
    saveRule,
    set4EyesEnabled,
    set4EyesFallbackUsers,
    setActiveWorkflow,
    setStepChange,
    setStepSettings,
    sortSteps,
} from "./workflowdetails.action";
import translate from "../translations/translations.wrapper.jsx";
import { formatDocumentType } from "utils/valueFormatter.function";
import { DOCUMENT_TYPE } from "utils/constants";
import {withRouter} from "components/router/withRouter.tsx";
import {Link} from "react-router-dom";
import {PATH_TO_WORKFLOWS} from "components/router/paths.js";
import { Switch } from "components/common/Switch.component";
import { Loader, LoaderSize } from "components/common/Loader.component.tsx";
import { ArrowLeftIcon } from "lucide-react";
import { ICON_SIZE } from "components/common/constants";

export function WorkflowDetailsHistory(props) {
    useEffect(() => {
        props.getOldWorkflowJSON(props.companyId, props.match.params.workflowId, props.match.params.version);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (props.workflow) {

        return (
            <div id="Workflow-details">
                <div
                    className="title-area d-flex justify-content-center">
                    <div
                        className="row px-40 workflows-center-align w-100">
                        <Link to={PATH_TO_WORKFLOWS} className="col-md-1 d-flex align-items-center mx-0"
                              aria-label={props.translate("workflowDetails.backToWorkflows")}
                              title={props.translate("workflowDetails.backToWorkflows")}>
                            <ArrowLeftIcon size={ICON_SIZE.MEDIUM} aria-hidden="true"/>
                        </Link>
                        <div className="col-md-5 d-flex align-items-center px-0">
                        <input type="text"
                                   className="disabled"
                                   value={props.workflow?.description || ""}
                            />
                        </div>
                        <div
                            className="d-flex col-md-6 justify-content-end px-0">
                            <div className="d-flex align-items-center">
                                <Switch isChecked={true}
                                        onChange={() => {}}
                                        isDisabled={true}
                                        label={props.translate("workflowDetails.active")}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    className="d-flex justify-content-center workflow-details-scroll">
                    <div className="px-40 workflows-center-align w-100">
                        <div className="row mb-4 mt-5 mx-0">
                            <div
                                className="col-md-2 document-type-title text-disabled d-flex align-items-center px-0">
                                    <span
                                        className={"mr-8 appicon appicon-block document-type-icon-24 " + formatDocumentType(props.workflow.documentType) + "-24"} />
                                {props.translate("documentType." + DOCUMENT_TYPE.asString(props.workflow.documentType))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (<div className="position-fixed top-50 w-100">
        <Loader size={LoaderSize.Medium} />
    </div>);
}

const withTranslations = translate(WorkflowDetailsHistory);

const WorkflowDetailsHistoryWithLocation = withRouter(withTranslations);
const mapStateToProps = function(store) {
    return {
        workflow: reduxSelectors.getOldWorkflowDetails(store),
        userRoles: reduxSelectors.getUsersRoles(store),
        usersBusinessFeatures: reduxSelectors.getUsersCurrentBusinessFeatures(store),
        companyId: reduxSelectors.getUsersCurrentContextId(store),
    };
};

const connected = connect(mapStateToProps, {
    getRuleConfigurationRoles,
    getCostUnits,
    getOrganizationChart,
    setActiveWorkflow,
    sortSteps,
    setStepSettings,
    setStepChange,
    set4EyesEnabled,
    set4EyesFallbackUsers,
    removeActiveWorkflow,
    saveRule,
    renameRule,
    removeStep,
    getOldWorkflowJSON,
})(WorkflowDetailsHistoryWithLocation);

export default connected;